import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import {
    AfterContentInit,
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';

import { AtxBreadcrumbService } from '../services';
import { AtxAutoUnsubscribe } from '../../../other/decorators/auto-unsubscribe';

@AtxAutoUnsubscribe()
@Component({
    selector: 'atx-breadcrumb',
    template: `<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <ng-container *ngFor="let element of model; let last = last">
            <li class="breadcrumb-item"
                *ngIf="element"
                [class.active]="last"
                [attr.aria-event]="ariaEvent"
                [attr.aria-current]="last && 'page'">

                <div *ngIf="!last;then link else span"></div>

                <ng-template #link>
                    <ng-container *ngIf="hasEvent">
                        <a (click)="onClickEvent()">{{ 'breadcrumb.link.' + element?.label }}</a>
                    </ng-container>

                    <ng-container *ngIf="!hasEvent">
                        <a href="#">{{ 'breadcrumb.link.' + element?.label }}</a>
                    </ng-container>
                </ng-template>

                <ng-template #span>
                    <span>{{ 'breadcrumb.label.' + element?.label }}</span>
                </ng-template>
            </li>
        </ng-container>
    </ol>
</nav>
`,
    styles: [`::ng-deep .breadcrumb a{cursor:pointer}`],
})

export class AtxBreadcrumbComponent implements OnInit, OnDestroy {
    @Input() public readonly hasRefresh: boolean = true;
    @Input() public readonly initLabel: string = 'init';

    @Output('onClick') public readonly fireClick: EventEmitter<null> = new EventEmitter();

    public model;
    public hasEvent;
    public ariaEvent: boolean;

    private breadcrumb$: Subscription;

    constructor(
        private readonly router: Router,
        private readonly service: AtxBreadcrumbService,
    ) {}

    public ngOnInit() {
        this.hasEvent = !!this.fireClick.observers.length;

        if (this.hasRefresh) {
            this.promiseRouterEvents();
        } else {
            this.model = this.service.getNavigationAfterRedirect(this.router.routerState.snapshot, this.initLabel);
        }

    }

    public onClickEvent() {
        this.ariaEvent = !this.ariaEvent;
        this.fireClick.emit();
    }

    public ngOnDestroy() {
        // TODO: REMOVE SUBSCRIBE WITH ATX AUTO UNSUBSCRIBE
    }

    private promiseRouterEvents() {
        this.breadcrumb$ = this.router.events
            .subscribe((navigation: any) => {
                if (navigation.url) {
                    this.model = this.service.getNavigationAfterRedirect(navigation, this.initLabel);
                }
            });
    }
}
